import React from 'react';
import PropTypes from 'prop-types';
import { mergeClasses } from '@fluentui/react-components';
import { EmptyViewIcons } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';

import { useVideoEmptyViewStyle } from '../../styles';

export const VideoEmptyView = ({ i18n, isFilterResult }) => {
  const classes = useVideoEmptyViewStyle();

  return (
    <div className={classes.emptyView}>
      <div className={classes.emptyIcon}>
        <img src={EmptyViewIcons.VideoEmptyViewSVG} alt="Empty Icon" />
      </div>
      <div className={mergeClasses('no-video', classes.mainText)}>
        {isFilterResult ? i18n.getString(_TL_('No videos match your search. Please try again.')) : i18n.getString(_TL_('You haven\'t added any videos yet. Choose from the options above.'))}
      </div>
    </div>
  );
};

VideoEmptyView.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  isFilterResult: PropTypes.bool,
};

VideoEmptyView.defaultProps = {
  isFilterResult: false,
};
